import { FETCH_WEATHER } from '../actions/index';

export default (prevState = null, action) => {
	switch (action.type) {
		case FETCH_WEATHER:
			if (action.error) {
				return true;
			}
			return null;
		default:
			return null;
	}
};



// WEBPACK FOOTER //
// ./src/reducers/WeatherError.js